import React from 'react';
import './SuccessValidationForm.scss';
import ContainerValidation from '../../Dashboard/Visitor/External/Components/ContainerValidation';
import HeaderValidation from '../../Dashboard/Visitor/External/Components/HeaderValidation';
import routes from '../../../Routes/routes';
import {getUrlParameters, TAB_INDEX} from '../../Dashboard/Visitor/External/Model/Model';
import BodyValidation from '../../Dashboard/Visitor/External/Components/BodyValidation';
import SuccessValidationFormApp from '../Functionality/SuccessValidationFormApp';
import FieldsValidation from './FieldsValidation';
import SuccessIdentity from './SuccessIdentity';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SuccessValidationForm = () => {

    const {
        id,
        guardFlowId,
        t,
        modifiedData,
        activeStep,
        loading,
        handleSubmit,
        handleChange,
        isValidDocumentId,
        validateDocumentIdChanges
    } = SuccessValidationFormApp();

    return (
        <>
            <ContainerValidation>
                <HeaderValidation
                    activeStep={activeStep}
                    steps={3}
                    url={getUrlParameters({ url: routes.invitationDetails.invitation, id, guardFlowId })}
                    showBtnBack={activeStep === TAB_INDEX.ONE}
                    headerCenter={
                        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 text-center">{t("identity_validation_title")}</p>
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 d-none d-sm-block">{"•"}</p>
                            <p className="fs-16-to-12 ibl-font-w-400 font-color-general-950 text-center">{`${t("step")} ${activeStep} ${t("of")} ${2} `}</p>
                        </div>
                    }
                />

                <BodyValidation
                    click={() => {
                        handleSubmit();
                    }}
                    showBtnNext={!loading}
                    classWith="content-center-w-600px gap-1"
                    btnDisabled={!modifiedData.isValid() || !isValidDocumentId}
                >
                    <div className="w-100">
                        {activeStep === TAB_INDEX.ONE &&
                            <FieldsValidation
                                modifiedData={modifiedData}
                                handleChange={(e) => { handleChange(e) }}
                                isValidDocumentId={isValidDocumentId}
                                validateDocumentIdChanges={validateDocumentIdChanges}
                            />
                        }
                        {activeStep === TAB_INDEX.TWO &&
                            <SuccessIdentity
                                loading={loading}
                            />
                        }
                    </div>
                </BodyValidation>
            </ContainerValidation>
        </>
    );
};
export default SuccessValidationForm;
